import {SafeAny} from '@/types';
import {http} from '@/utils';
import {getAdjustAttribution} from '@/utils/adjust';
import type {
  BalanceListItem,
  PayMethod,
} from '@fe-progressive/package-progressive/recharge';

export type {BalanceListItem, PayMethod};

export interface IncomeModel {
  balanceId: string | 0;
  payTypeId: string;
  rechargeBalance: string | 0;
  payTag: string;
  payCategory?: number;
}

export interface IncomeResModel {
  orderNo: string;
  packageId: number;
  upiId: string;
}

export interface PayCallbackModel {
  orderNo: string;
  tradeResult: string;
  approvalUrt: string;
}

export const getBalanceList = (useType?: number) => {
  return http.post<{useType?: number}, BalanceListItem[]>(
    'app/pay/balance/list',
    {
      useType,
    },
  );
};

export const goIncome = (incomeData: IncomeModel) => {
  return http.post<IncomeModel, string | IncomeResModel>(
    'app/pay/income',
    incomeData,
  );
};

export const getPayMethod = (useType?: number) => {
  const attribution = getAdjustAttribution();
  return http.post<{channelUser: number; useType?: number}, PayMethod[]>(
    'app/pay/type/active/list',
    {
      channelUser:
        attribution?.tracker_name &&
        attribution.tracker_name.toLowerCase() !== 'organic'
          ? 1
          : 0,
      useType,
    },
  );
};

export const paySuccess = (payCallback: PayCallbackModel) => {
  return http.post<SafeAny>('app/callback/upi/result', payCallback);
};
